module.exports = __webpack_public_path__ + "static/media/blogger.6e32e2c3.svg";